import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { EditPortfolioForm } from './EditPortfolioForm'

export function EditPortfolioCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const actions = useHook('mutators.unitlink.useEditPortfolioActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.EditPortfolioCommandData"
      title={translate('editPortfolioModalButton.title')}
      commandDataForm={EditPortfolioForm}
      {...props}
      submit={submit}
    />
  )
}
